import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetFundrasing } from '../../store/fundrasing'
import { useState } from 'react'
import { paymentHistoryExportColumns } from '../../config/exportColumns/paymentHistoryExportColumns'
import { useDispatch } from 'react-redux'

function PaymentHistory() {
	// const navigate = useNavigate();
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	const finalSansthaId = sansthaId || permissionOfSanstha

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Payment History</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetFundrasing({
										...params,
										...exportFilters,
										page: 1,
										limit: 100000,
										sanstha: finalSansthaId,
										loading: false,
									}),
								)
							}
							columns={paymentHistoryExportColumns}
							fileName="Payment_History"
							sheetName="Payment History"
							buttonText="Export Payment History"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default PaymentHistory
